import React from 'react';
import {useSelector} from 'react-redux';

import appContent from '@/services/content/appContent';
import {selectIsDeviceConnected} from '@/state/selectors/mw';

const ConnectionStatus = () => {
    const isDeviceConnected = useSelector(selectIsDeviceConnected);
    const {connectedStatusTitle, disconnectedStatusTitle} = appContent.getDeviceStatusContent();

    return (
        <span className='text-14 font-bold tracking-02 text-black'>
            {isDeviceConnected ? connectedStatusTitle : disconnectedStatusTitle}
        </span>
    );
};

export default ConnectionStatus;
